module.exports = __webpack_public_path__ + "img/cost-icon__alberca_olimpica.3269c85a.svg";